<template>
<div class="chapter">
<div class="inner_page">
<p class="chap-title"><span>BLUE YODEL 5</span></p>
<p class="chap-subtitle1"><span>VINNIE AND DOM</span></p>
<p class="indent"><i><span class="smallcaps">VINNIE</span>: … things these days. My mother wants to know why I won’t let her ride the bus to St. Mary the Virgin. I say, “Because you got bit in the back of the neck, Ma.” Guy on the bus bit my mother in the back of the neck! I hit the guy … I</i> found <i>the guy. I hit the guy</i>…</p>
<p class="indent"><i><span class="smallcaps">DOM</span>: Guys like that shouldn’t be hit. Guys like that, you should kill ’em</i>.</p>
<p class="indent"><span class="smallcaps"><i>VINNIE</i>:</span> <i>I beat the</i> shit <i>out of the guy</i>.</p>
<p class="indent"><i><span class="smallcaps">DOM</span>: Guys like that, you shouldn’t beat the shit out of them. You should kill guys like that</i>.</p>
<p class="indent"><i><span class="smallcaps">VINNIE</span>: She says she wishes she didn’t tell me. I say, “Ma, you</i> told <i>me. Just go to St. Francis’s up the block here.” She says but at St. Mary the Virgin the stations of the cross are prettier. I say, “Ma, our Savior didn’t tell us, seek out a place with pretty stations of the cross to go to mass.” She says she don’t understand. I say, “Ma, you have to listen to me now. If you don’t understand, I can’t tell you. Don’t take the bus no more</i>.”</p>
<p class="indent"><i><span class="smallcaps">DOM</span>: Guys like that, you ought to kill ’em</i>.</p>
<p class="indent"><i><span class="smallcaps">VINNIE</span>: What does she want me to say? “You want a son that went to the penitentiary for murder and had to fight off six-foot-six black bodybuilder fruits with a sharpened bedspring for the rest of his life because you got to ride the bus to see the prettier stations of the cross at St. Mary the Virgin?”?</i></p>
<p class="indent"><i><span class="smallcaps">DOM</span>: Just kill ’em. That’s all</i>.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter09.vue?d92d3284